import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { SharedService } from "@shared/services/shared.service";
import { IEnclosedAreaEditHistory } from "app/models/reports/reports";
import { ComplaintService } from "app/services/complaint/complaint.service";

@Component({
  selector: 'enclosedAreaHistory',
  styleUrls: ['./enclosedAreaHistory.component.scss'],
  templateUrl: './enclosedAreaHistory.component.html'
})

export class EnclosedAreaHistoryComponent implements OnInit {

  businessId: number = 0;
  saved: boolean = false;
  showSave: boolean = false;
  reviewed: boolean = false;
  followupInspection: boolean = false;
  siteVisitConducted: boolean = false;
  historyList: IEnclosedAreaEditHistory[] = [];

  displayedColumns: string[] = ['enclosedAreaDetermination', 'enclosedAreaDeterminationComments', 'loggedUser', 'timeStamp'];
  dataSource = new MatTableDataSource<IEnclosedAreaEditHistory>(this.historyList);

  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;


  constructor(
    private sharedService: SharedService,
    private complaintService: ComplaintService,
    private dialogRef: MatDialogRef<EnclosedAreaHistoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (this.data.history != null && this.data.history != undefined) {
      this.historyList = this.data.history;
      this.dataSource.data = this.historyList;
    }
  }

  ngOnInit(): void {
    this.saved = false;
  }

  return(): void {
    this.dialogRef.close();
  }
}